import type { WebsiteHeaderPhotoSchema_PhotoMarquee } from '@shared/types/WebsiteHeaderSettings.types';

export const PHOTO_MARQUEE_DEFAULT: WebsiteHeaderPhotoSchema_PhotoMarquee = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoMarquee-v1_1_1.json',
  presentationLayout: 'photoMarquee',
  photos: [],
};
